import React from "react";
import "./NewBadge.css";

/**
 * Chip "NUEVO" para resaltar features del último release.
 * Por defecto se ancla a la esquina top-right del padre (que debe tener position: relative).
 *
 * Props:
 *   size      "sm" | "md"   tamaño del chip (default "md")
 *   pinned    boolean       si es false, fluye inline (default true)
 *   label     string        texto a mostrar (default "NUEVO")
 *   className string        clases extra
 */
const NewBadge = ({
    size = "md",
    pinned = true,
    label = "NUEVO",
    className = "",
    ...rest
}) => {
    const classes = [
        "new-badge",
        `new-badge--${size}`,
        pinned ? "new-badge--pinned" : "new-badge--inline",
        className,
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <span className={classes} aria-label="Nueva funcionalidad" {...rest}>
            <span className="new-badge__mark" aria-hidden="true">✦</span>
            <span className="new-badge__label">{label}</span>
        </span>
    );
};

export default NewBadge;
